import React, { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { Modal } from '@gerdau/hefesto';
import { Container } from './styles';
import { AccessInternalManagementService } from '../../../../services/AccessInternalManagement';
import { useDispatch } from 'react-redux';
import { EToastTypes } from '../../../../store/ducks/toast/types';
import { addToast } from '../../../../store/ducks/toast/actions';
import { IInternalUser } from '../../../../store/ducks/internal-user/types';

interface IRemoveInternalUserModalProps {
  id: string;
  name: string;
  onClose: () => void;
  setSellerReps: Dispatch<SetStateAction<IInternalUser[]>>;
}

const RemoveInternalUserModal: React.FC<IRemoveInternalUserModalProps> = ({
  id,
  name,
  onClose,
  setSellerReps
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleDeleteUser = useCallback(async () => {
    setIsLoading(true);
    AccessInternalManagementService.deactivateSellerRep(id)
      .then(() => {
        dispatch(
          addToast({
            message: `Usuário ${name} removido com sucesso!`,
            type: EToastTypes.SUCCESS
          })
        );
        setSellerReps((oldState) => oldState.filter((el) => el.id !== id));
        setIsLoading(false);
        onClose();
      })
      .catch(() => {
        dispatch(
          addToast({
            message: `Erro ao remover o usuário!`,
            type: EToastTypes.DANGER
          })
        );
        setIsLoading(false);
      });
  }, [id, AccessInternalManagementService, setSellerReps, name, onClose]);

  return (
    <Container>
      <Modal
        onClose={() => onClose()}
        modalSize="sm"
        title={'Deseja realmente excluir esse usuário?'}
        buttons={{
          left: {
            children: 'Cancelar',
            name: 'Cancelar',
            onClick: () => {
              onClose();
            },
            type: 'button'
          },
          right: {
            children: 'Excluir usuário',
            name: 'Excluir usuário',
            variant: 'danger',
            onClick: () => {
              handleDeleteUser();
            },
            type: 'button',
            loading: isLoading
          }
        }}
      >
        <span className="subtitle" data-testid="subtitle">
          Caso exclua o usuário <strong>{name}</strong>, não será possível
          desfazer esta ação.
        </span>
      </Modal>
    </Container>
  );
};

export default RemoveInternalUserModal;
